// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2vzHE","row":"Node_row__3bzc7","label":"Node_label__3s3y3","footer":"Node_footer__3Ss0t"};